//INDEX BANNER SLIDER

const bannerSliderElm = document.querySelector('.index_banner_wrapper .splide');
if(bannerSliderElm){
    const bannerSlider = new Splide( bannerSliderElm, {
        type   : 'loop',
        arrows : true,
        pagination: true
    });

bannerSlider.mount();
}

//blog filter


  const filterBy = document.querySelector('[data-blog-tag-filter]');

  if (filterBy){
    filterBy.addEventListener('change', function(evt) {
      location.href = evt.target.value;
    });
  }


  //faq 

const accordions = document.querySelectorAll('.faqInner');

if (accordions) {
  accordions.forEach(wrapper => {
    const titles = wrapper.querySelectorAll('.accordiOn');
    const panels = wrapper.querySelectorAll('.panel');

    titles.forEach((title, index) => {
      const panel = title.nextElementSibling;

      title.addEventListener('click', () => {
        const isOpen = title.classList.contains('active');

       
        titles.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.style.maxHeight = null);

      
        if (!isOpen) {
          title.classList.add('active');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });

     
      // if (index === 0) {
      //   title.classList.add('active');
      //   panel.style.maxHeight = panel.scrollHeight + 'px';
      // }
    });
  });
}

//color pallets 

const color_plt = document.querySelector('.color_plt');
if (color_plt) {
  new Splide(color_plt, {
    type: 'loop',
    autoplay: true,
    pagination:false,
    arrows:false,
    speed: 1000,
    perPage: 3,
  }).mount();
}

//personalised gallery 

const personalised_glry = document.querySelectorAll('.personalised_glry');

personalised_glry.forEach((glry)=>{

  new Splide(glry, {
    type: 'loop',
    autoplay: true,
    pagination:false,
    arrows:false,
    speed: 1000,
    autoWidth: true,
  }).mount();

})


const filterIcn = document.querySelector('.filter-box #showHide_Icon');
const filters_content = document.querySelector('.filter-box .filters_content');

if(filterIcn){
  filterIcn.addEventListener('click',()=>{
    filters_content.classList.toggle('active');
  })
}

  


 
